import { Component as BaseComponent, h } from 'preact';
import { connect } from 'preact-redux';

class Component extends BaseComponent {
    render({logged_in, submitting, sale_price_code}) {
        const button_text = submitting ? 'submitting…' : 'purchase coins';

        let label = 'logged-out';
        if (logged_in) {
            label = sale_price_code == 'first-time-buyer' ? '1st-kc-package' : '2nd-or-more-kc-package';
        }

        return (
            <karmacoin-submit>
                <button
                  onClick={(e) => this.trackClick(e, submitting, label)}
                  class='button-warning'
                >{button_text}</button>
            </karmacoin-submit>
        );
    }

    trackClick(e, submitting, label) {
        e.preventDefault();

        if (!submitting) {
            this.props.trackEvent(label);
            this.props.purchase();
        }

        return false;
    }
}

const mapStateToProps = (state) => ({
    logged_in: state.user && state.user.logged_in,
    submitting: state.product.submitting,
    sale_price_code: state['karmacoin-store'].packages && state['karmacoin-store'].packages.standard[0].sale_price_code,
});

const mapDispatchToProps = (dispatch) => ({
    purchase: () => dispatch({ type: 'karmacoin-store:purchase' }),
    trackEvent: (label) => dispatch({ type: 'ga:event', payload: [ 'kc-store', 'Click-Purchase-Button', label ] }),
});

export default connect(mapStateToProps, mapDispatchToProps)(Component);



// WEBPACK FOOTER //
// ./app/components/karmacoin-store/karmacoin-submit.js